<app-model-comparison
  [comparisons]="data$ | async"
  [offers]="offers$ | async"
  [previousUrl]="previousUrl$ | async"
  (selected)="onComparisonSelectedClick($event)"
  (removed)="onComparisonRemovedClick($event)"
></app-model-comparison>
